import React from "react"
import { graphql } from "gatsby"

import Seo from "../components/seo"
import Content from "../components/content"
import Layout from "../components/layout"
import AboutArctus from "../components/about"
import Title from "../components/title"
import Spacer from "../components/spacer"
import Banner from "../components/banner"
import { ModularContent } from "../components/modularContent"

const Press = ({ data: { press, about } }) => {
	return (
		<Layout>
			<Banner image={press.image} />
			<Spacer className='m-hide' />
			<Title title={press.title} date={press.meta.createdAt} hideDate={press.hidePublishedAtDate} hideRelease={press.hideForImmediateRelease} />
			<Content subtitle={press.subtitle} content={press.content} map={press.iframe} />
			<ModularContent modules={press.additionalContent} />
			<div className='p20 max-950 ma'>
				<div className='divider' />
			</div>
			{!press.hideAbout && <AboutArctus title={about.title} content={about.content} />}
			<Spacer />
		</Layout>
	)
}

export default Press

export const Head = ({ data: { press } }) => <Seo title={press.title} />

export const datoQuery = graphql`
	query PressRelease($slug: String!) {
		press: datoCmsPress(slug: { eq: $slug }) {
			slug
			title
			hidePublishedAtDate
			hideForImmediateRelease
			iframe
			meta {
				createdAt(formatString: "MMMM D, YYYY")
			}
			image {
				gatsbyImageData
			}
			subtitle
			content
			additionalContent {
				... on DatoCmsContent {
					id
					content
				}
				... on DatoCmsImage {
					id
					image {
						gatsbyImageData
					}
				}
				... on DatoCmsVideo {
					id
					youtubeVideo {
						url
						providerUid
						title
					}
				}
				... on DatoCmsTableLayout {
					id
					tableHeader {
						id
						one
						two
						three
					}
					rows {
						id
						rowItems {
							... on DatoCmsRowItemImage {
								id
								image {
									gatsbyImageData
								}
							}
							... on DatoCmsRowItemText {
								id
								text
							}
						}
					}
				}
			}
			hideAbout
		}
		about: datoCmsAbout {
			title
			content
		}
	}
`
